import React from "react"
import styled from "styled-components"
import { MobergFontSize } from "../MobergFont/MobergFont"
import { MobergAnimationCurve, MobergAnimationTiming } from "../MobergAnimation/MobergAnimation"
import { getPreloadStatusPaletteName, getStatusPalette } from "./statusPalette"
import type { PreloadDisplayStatus } from "./preloadStatus"

interface PillStyle {
    border: string
    color: string
    background: string
}

function getPreloadStatusStyle(status: PreloadDisplayStatus): PillStyle {
    return getStatusPalette(getPreloadStatusPaletteName(status.kind))
}

const Pill = styled.span<{ $status: PreloadDisplayStatus }>`
    border: 1px solid ${props => getPreloadStatusStyle(props.$status).border};
    color: ${props => getPreloadStatusStyle(props.$status).color};
    padding: 4px 12px;
    border-radius: 16px;
    font-size: ${MobergFontSize.SMALL};
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
    min-width: 62px;
    text-align: center;
    background: ${props => getPreloadStatusStyle(props.$status).background};
    transition: all ${MobergAnimationTiming.FAST} ${MobergAnimationCurve.EASE_IN};
`

export function PreloadStatusPill({ status }: { status: PreloadDisplayStatus }): JSX.Element {
    return <Pill $status={status}>{status.label}</Pill>
}
